import {useEffect, useState} from "react";
import {signIn, useSession} from "next-auth/react";
import {isJsonString} from "@/lib/utils";
import {Button, Checkbox, Form, Input, Layout, Spin} from 'antd';
import {myLinks} from "@/lib/routes/myLinks";
import style from './style.module.scss'
import {Icon} from "./icon_ddd";
import {useNotification} from "@/lib/hook";
import { useRouter } from 'next/navigation'

export const SignIn = () => {
    const {status} = useSession()
    const route = useRouter()

    useEffect(()=>{
        if (status === 'authenticated'){
            route.replace(myLinks.getUlr('users.index'))
        }
    }, [])

    return(
        <>
            <Layout
                style={{
                    minHeight: '100vh',
                }}
            >

                <Layout>
                    <Layout.Content
                        className={style.wrapper}
                    >
                        <div className={style.form_wrapper}>
                            <div className={style.form_content}>
                                <div className={style.form_title_wrapper}>
                                    <div className={style.title}>
                                        Sign In
                                    </div>
                                    <div className={style.sun_title}>
                                        Enter your email & password to login
                                    </div>
                                </div>
                                <div className={style.form}>
                                    <SingInForm/>
                                </div>
                            </div>
                            <div className={style.footer}>
                                Design by Hardevs
                            </div>
                        </div>
                    </Layout.Content>
                </Layout>
                <Layout.Sider
                    className={style.sider}
                    breakpoint="xl"
                    collapsedWidth="0"
                    trigger={null}
                    width={'100%'}
                >
                    <div className={style.sider_bg}>
                        <div className={style.sider_wrapper}>
                            <div className={style.sider_content}>
                                <div style={{marginBottom: 40}}>
                                    <Icon />
                                    <div className={style.title}>
                                        Welcome
                                    </div>
                                    <div className={style.sub_title}>
                                        to Admin System
                                    </div>
                                    <div className={style.line} />
                                    <div className={style.desc}>
                                        Welcome to the admin panel! Here,
                                        youre in full control. Manage settings,
                                        content, and users, making your administrative
                                        experience seamless and efficient.
                                        Onward to success!
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Layout.Sider>
            </Layout>
        </>
    )
}

const SingInForm = () =>{
    const router = useRouter()

    const send = useNotification()
    const [loading, setLoading] = useState(false)

    const onFinish = async (data) => {
        setLoading(true)

        const resp = await signIn('credentials',
            {
                ...data,
                redirect: false,
            }
        )
        if (resp.status !== 200) {
            if (isJsonString(resp.error)) {
                const er = JSON.parse(resp.error)
                if (er.status === 503) {
                    // await router.push('/503')
                } else {
                    send({
                        type: 'error',
                        description: <div dangerouslySetInnerHTML={{__html: er.message}} />,
                    })
                }
            } else {
                send({
                    type: 'error',
                    description: <div dangerouslySetInnerHTML={{__html: resp.error}} />,
                })
            }
            setLoading(false)
        } else {
            router.replace(myLinks.getUlr('users.index'))
        }
    }

    return (
        <>
            <Spin spinning={loading}>
                <Form
                    name="login"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item
                        label="Email Address"
                        name="email"
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="password"
                    >
                        <Input.Password/>
                    </Form.Item>

                    <Form.Item
                        name="remember"
                        valuePropName="checked"
                    >
                        <Checkbox>Remember</Checkbox>
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{
                                width: '100%',
                                height: '48px',
                            }}
                        >
                            Sign In
                        </Button>
                    </Form.Item>
                </Form>
            </Spin>
        </>
    )
}